module.exports = __webpack_public_path__ + "assets/img/17a8-ag.svg";